export default __webpack_public_path__ + "static/media/blood-drop.a56cd6ed.png";